import { useQuery } from '@tanstack/react-query';
import axios from 'axios';
/**
 * Fetches the participant (patient) web app URL for an environment from the Axon
 * `get_study_url` route. This is the authoritative source for the URL: it is resolved
 * server-side and must be used instead of deriving it from the local environment, whose
 * cortex hostname does not reliably map to the participant web host.
 *
 * The route is always called anonymously (`withCredentials: false`, SSP-4011); it must not
 * depend on a Medable session cookie.
 *
 * @param cortexUrl - The environment cortex base URL (e.g. `https://api-int-dev.medable.com`).
 * @param code - The environment/org code.
 * @returns The resolved web app URL (or `null` when unavailable) plus query status.
 *
 * @public
 */
export const useParticipantWebAppUrl = ({ cortexUrl, code }) => {
    const { data: participantWebAppUrl = null, isLoading, isError, } = useQuery({
        enabled: !!cortexUrl && !!code,
        retry: false,
        queryKey: ['cortex', code, 'get_study_url'],
        queryFn: async () => {
            const { data } = await axios.get(`${cortexUrl}/${code}/v2/routes/get_study_url`, {
                headers: { 'Medable-Client-Key': 'MedableIAMDefaultClientKey' },
                withCredentials: false,
            });
            return data.data.paweb_url || null;
        },
    });
    return { participantWebAppUrl, isLoading, isError };
};
